import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import { tokens, select_style, total, success, alert, toFixed, GET, POST, DELETE, format_date, getStorage, roundToTwo, loading,calculate_water } from "../../components/CustomComponent.js";
import { report_water_bill } from "../../components/ReportWaterBill.js";

const select_role = getStorage("role_detail")?.find((item) => item.name === "bill-water")?.role || [];
const view_r = select_role[0] === 1;
const create_r = select_role[1] === 1;
const delete_r = select_role[3] === 1;

export default class BillWater extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false, 
      modal_delete: false, 
      rw_number: "", 
      page: 1, 
      filter_address_number: null, 
      data: null, 
      data_address: [], 
      record_receipt_id: "",
      address_number: ""
    };
  }

  async componentDidMount() {
    loading(false); // สั่งปิด Load ทันทีเมื่อเข้ามาหน้าครั้งแรกตามเงื่อนไข
    if (view_r) {
      loading(true);
      try {
        await Promise.all([this.GetRunningNumber(), this.GetAll(), this.GetAddressAll()]);
      } finally {
        loading(false);
      }
    }
  }

  fields = [
    { k: "add_debt", sk: "s_add_debt" }, { k: "cable_cost", sk: "s_cable_cost" }, { k: "common_expenses", sk: "s_common_expenses" },
    { k: "equipment_maintenance_fee", sk: "s_equipment_maintenance_fee" }, { k: "fire_cost", sk: "s_fire_cost" }, 
    { k: "late_payment", sk: "s_late_payment", vk: "total_cost_late" }, { k: "meter_connect_cost", sk: "s_meter_connect_cost" },
    { k: "other_income", sk: "s_other_income" }, { k: "reduce_debt", sk: "s_reduce_debt" }, 
    { k: "waste_cost", sk: "s_waste_cost" }, { k: "water_bill", sk: "s_water_bill" }
  ];

  GetAddressAll = async () => {
    let res = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (res?.status) {
      this.setState({ data_address: res.data.data.map(item => ({ value: item.address_number, label: `อาคาร ${item.building} ห้อง ${item.address_number}` })) });
    }
  };

  GetAll = async () => {
    loading(true);
    try {
      let res = await GET(tokens, `v1/TH/bill-water-group/filter-search/${getStorage("project_id")}`, { data_search: this.state.filter_address_number?.value || "" });
      if (res?.status) {
        let array = res.data;
        array.data.forEach(d => {
          if (!d.water_bill && !d.equipment_maintenance_fee && !d.common_expenses && !d.waste_cost) {
            d.other_income = d.total_final;
          }
          let sum = 0;
          this.fields.forEach(({ k, sk }) => {
            if (d[sk] === false) d[k] = 0;
            else sum += Number(d[k] || 0);
          });
          let sum_unit_used = 0;
          let count_bill = 0;
          d.transaction_payments.forEach(p => {
            if( p.s_add_debt || p.s_cable_cost || p.s_common_expenses || p.s_equipment_maintenance_fee || p.s_fire_cost || p.s_late_payment || p.s_meter_connect_cost || p.s_other_income || p.s_reduce_debt || p.s_waste_cost || p.s_water_bill ){
              sum_unit_used += Number(p.unit_used || 0);
              count_bill += 1;
            }
          });

          d.total_amount = sum;
          d.sum_unit_used = sum_unit_used || d.sum_unit_used || 0;
          d.count_bill = count_bill || d.count_bill || 0;
          d.add_debt = Number(d.add_debt || 0) + Number(d.add_on_add_debt || 0);
          d.reduce_debt = Number(d.reduce_debt || 0) + Number(d.add_on_reduce_debt || 0);
        });
        this.setState({ data: array });
      }
    } finally {
      loading(false);
    }
  };

  GetRunningNumber = async () => {
    let res = await GET(tokens, `v1/TH/record-receipt/running-iw/${getStorage("project_id")}`, { format_doc: "RW" });
    if (res?.status) this.setState({ rw_number: res.data.data });
  };

  Create = async () => {
    loading(true);
    try {
      // ใบเสร็จที่ถูกยกเลิกแล้วต้องไม่ถูกนำส่ง ไม่งั้นยอดของกลุ่มนำส่ง (Bill_water_group) จะรวมเงินที่ไม่ได้รับจริง
      const all_rows = this.state.data?.data || [];
      let bill_list = all_rows.filter(item => item.status_bill !== 2).map(item => item.record_receipt_id);
      // NOTE ถ้าเหลือแต่แถวที่ยกเลิก bill_list จะว่าง — หลังบ้านรองรับ (ปิดงานแบบไม่มียอดนำส่ง) จึงส่งไปได้
      // กันเฉพาะกรณีไม่มีแถวอะไรเลย (เช่น modal ค้างเปิดอยู่ตอนข้อมูลถูกรีเฟรชจนว่าง)
      if (all_rows.length === 0) {
        this.clear_form();
        alert("warning", "แจ้งเตือน", "ไม่มีรายการให้ปิดงาน");
        return;
      }
      let payload = {
        rw_number: this.state.rw_number,
        bill_list,
      };
      let res = await POST(tokens, `v1/TH/bill-water-group/create/${getStorage("project_id")}`, payload);
      if (res?.status) {
        await GET(tokens, "http://127.0.0.1:8181/backup", null);
        this.clear_form();
        success();
        await Promise.all([this.GetAll(), this.GetRunningNumber()]);
      }
    } finally {
      loading(false);
    }
  };

  Delete = async () => {
    loading(true);
    try {
      let res = await DELETE(tokens, `v1/TH/bill-water-group/delete/${this.state.record_receipt_id}`, { delete_remark: "" });
      if (res?.status) {
        if(this.state.address_number){
          await calculate_water(this.state.address_number);
        }
        this.clear_form();
        success();
        await Promise.all([this.GetAll(), this.GetRunningNumber()]);
      }
    } finally {
      loading(false);
    }
  };

  clear_form = () => this.setState({ modal_create: false, modal_delete: false, rw_number: "", page: 1, filter_address_number: null, record_receipt_id: "" });

  Print = async (iw_number) => {
    loading(true);
    try {
      let res = await GET(tokens, `v1/TH/record-receipt/history/by-iw-number/${getStorage("project_id")}`, { iw_number });
      if (res?.status) {
        let data = res.data.data;
        console.log("data for print", data);
        report_water_bill(data,data.iw_number,data.change_satang,data.add_on_add_debt,data.add_on_reduce_debt);
      } else {
        alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
        this.clear_form();
      }
    } finally {
      loading(false);
    }
  };

  render() {
    const { data, data_address, filter_address_number, rw_number, modal_create, modal_delete } = this.state;

    // Helpers สำหรับ Format ตัวเลข
    const val = (v) => v ? toFixed(v) : "0.00";
    // NOTE ใบเสร็จที่ถูกยกเลิกแล้ว (status_bill = 2) ยังแสดงในตารางเพื่อดูประวัติ
    // แต่ห้ามนับรวมในยอด "จัดเก็บได้ แต่ยังไม่นำส่ง" ไม่งั้นยอดนำส่งจะเกินเงินจริง
    const activeRows = data ? data.data.filter((e) => e.status_bill !== 2) : [];
    // จำนวนใบที่ยกเลิก นับจากแถวที่ยังเห็นในตาราง ไม่ใช้ค่าจากหลังบ้านที่อาจค้าง ปิดงานแล้วแถวหายก็เป็น 0
    const cancelledCount = data ? data.data.length - activeRows.length : 0;
    const t = (k) => toFixed(total(activeRows, k));
    const calcSum = (i) => (i.water_bill||0) + (i.equipment_maintenance_fee||0) + (i.common_expenses||0) + (i.waste_cost||0) + (i.cable_cost||0) + (i.other_income||0) + (i.fire_cost||0) + (i.late_payment||0) + (i.meter_connect_cost||0) + (i.change_satang||0) + (i.add_debt||0) - (i.reduce_debt||0);
    const footerOtherInc = activeRows.reduce((sum, i) => sum + (calcSum(i) !== 0 ? (i.other_income || 0) : (i.total_final || 0)), 0);

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="การจัดเก็บค่าใช้จ่าย" />

        <div className="body">
          <div className="p-3">
          <div className="card border-0 p-3">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h4 className="mb-0"><b>การจัดเก็บค่าใช้จ่าย {rw_number ? `เลขที่เอกสาร : ${rw_number}` : ""}</b></h4>
            </div>

            <div className="d-flex align-items-center justify-content-between mb-3">
              {view_r && (
                <div className="d-flex align-items-center">
                  <Select
                    className="bg-contain border-0 select-search wpx-200 mx-1"
                    styles={select_style} options={data_address}
                    onChange={(e) => this.setState({ filter_address_number: e })}
                    value={filter_address_number}
                  />
                  <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>ค้นหา</button>
                  <button className="btn btn-outline-primary px-3 mx-1" onClick={() => this.setState({ filter_address_number: null, page: 1 }, this.GetAll)}>รีเซ็ท</button>
                </div>
              )}
              {/* NOTE โชว์เมื่อมีแถวใดๆ (รวมแถวที่ยกเลิกล้วน) เพื่อให้ปิดงานเคลียร์ใบที่ยกเลิกค้างได้ */}
              {create_r && data?.data?.length > 0 && (
                <button className="btn btn-outline-primary mx-1" onClick={() => this.setState({ modal_create: true })}>ปิดงานนำเงินฝากส่งธนาคาร</button>
              )}
            </div>

            <div className="table-responsive">
              <table className="table text-nowrap">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    <th>เลขที่รับใบเสร็จ</th><th>บ้านเลขที่</th><th>วันที่ใบเสร็จรับเงิน</th><th>จำนวนเดือนที่ชำระ</th>
                    <th>จำนวนหน่วยที่ใช้</th><th>ค่าน้ำประปา</th><th>ค่ารักษาอุปกรณ์น้ำ</th><th>ค่าส่วนกลาง</th>
                    <th>ค่าขยะ</th><th>ค่าเคเบิล</th><th>ค่าใช้จ่ายอื่นๆ</th><th>ค่าเบี้ยประกัน</th><th>เพิ่ม/ลดหนี้</th>
                    <th>ค่าปรับชำระล่าช้า</th><th>ค่าต่อกลับมิเตอร์</th><th>ปรับปรุงยอดเงิน</th><th>รวมเป็นเงิน</th>
                    {delete_r && <th className="text-center">ยกเลิกรายการ</th>}
                    <th className="text-center">พิมพ์รายงาน</th>
                  </tr>
                </thead>
                <tbody>
                  {!data?.data?.length ? (
                    <tr><td colSpan={19} className="text-center">ไม่มีข้อมูล</td></tr>
                  ) : (
                    data.data.map((item, index) => (
                      <tr key={index}>
                        <td>{item.iw_number || "-"}</td>
                        <td>{item.address_number || "-"}</td>
                        <td>{item.record_date ? format_date(item.record_date, "dd/mm/yyyy") : "-"}</td>
                        <td>{item.count_bill || "0"}</td>
                        <td>{item.sum_unit_used || "0"}</td>
                        <td className="bg-blue-light">{val(item.water_bill)}</td>
                        <td className="bg-blue-light">{val(item.equipment_maintenance_fee)}</td>
                        <td className="bg-blue-light">{val(item.common_expenses)}</td>
                        <td className="bg-blue-light">{val(item.waste_cost)}</td>
                        <td className="bg-blue-light">{val(item.cable_cost)}</td>
                        <td className="bg-blue-light">{val(item.other_income || (calcSum(item) === 0 ? item.total_final : 0))}</td>
                        <td className="bg-blue-light">{val(item.fire_cost)}</td>
                        <td className="bg-blue-light">{val((item.add_debt || 0) - (item.reduce_debt || 0))}</td>
                        <td className="bg-blue-light">{val(item.late_payment)}</td>
                        <td className="bg-blue-light">{val(item.meter_connect_cost)}</td>
                        <td className="bg-blue-light">{val(item.change_satang)}</td>
                        <td>{toFixed(calcSum(item) || item.total_final)}</td>
                        {delete_r && (
                          <td className="text-center">
                            {item.status_bill === 2 ? <label className="text-danger m-0">ยกเลิก</label> : (
                              <span className="icon text-danger wpx-24 hpx-24 bg-danger-light rounded-1 d-inline-flex align-items-center justify-content-center m-0 pointer" onClick={() => this.setState({ modal_delete: true, record_receipt_id: item.record_receipt_id, address_number: item.address_number })}>
                                {"\uf2ed"}
                              </span>
                            )}
                          </td>
                        )}
                        <td className="text-center">
                          <span className="icon text-primary wpx-24 hpx-24 bg-primary-light rounded-1 d-inline-flex align-items-center justify-content-center m-0 pointer" onClick={() => {
                            if (item.record_other_list.length > 0) {
                              // อื่นๆ
                              report_water_bill(item);
                            } else {
                              // บิลน้ำ
                              this.Print(item.iw_number);
                            }
                          }}>
                            {"\uf02f"}
                          </span>
                        </td>
                      </tr>
                    ))
                  )}
                  <tr>
                    <td colSpan={5} className="text-right"><b>รวมเป็นเงินที่จัดเก็บได้ แต่ยังไม่นำส่งจำนวน</b></td>
                    <td><b>{t("water_bill")}</b></td><td><b>{t("equipment_maintenance_fee")}</b></td><td><b>{t("common_expenses")}</b></td>
                    <td><b>{t("waste_cost")}</b></td><td><b>{t("cable_cost")}</b></td><td><b>{toFixed(footerOtherInc)}</b></td>
                    <td><b>{t("fire_cost")}</b></td><td><b>{toFixed(total(activeRows, "add_debt") - total(activeRows, "reduce_debt"))}</b></td>
                    <td><b>{t("late_payment")}</b></td><td><b>{t("meter_connect_cost")}</b></td><td><b>{t("change_satang")}</b></td>
                    <td><b>{t("total_final")}</b></td><td colSpan={2}></td>
                  </tr>
                  <tr className="bg-contain">
                    <td colSpan={7} className="text-right"><b>หมายเหตุ : มีการรับชำระค่าใช้จ่ายจำนวน</b></td>
                    <td><b>{total(activeRows, "count_bill") || "0"}</b></td><td><b>รายการ</b></td>
                    <td colSpan={2} className="text-right"><b>ออกใบเสร็จรับเงินจำนวน</b></td>
                    <td><b>{activeRows.length || "0"}</b></td><td><b>ฉบับ</b></td>
                    <td colSpan={2} className="text-right"><b>มีการยกเลิกใบเสร็จจำนวน</b></td>
                    <td><b>{cancelledCount}</b></td><td><b>ฉบับ</b></td><td colSpan={2}></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* MODALS */}
        <Modal show={modal_create} onHide={() => this.setState({ modal_create: false })}>
          <Modal.Header><Modal.Title><b>ปิดงานนำเงินฝากส่งธนาคาร</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex mb-3"><label>{(this.state.data?.data || []).some((e) => e.status_bill !== 2)
              ? "ท่านแน่ใจว่าต้องการปิดงานนำเงินฝากส่งธนาคารหรือไม่"
              : "ตอนนี้เหลือแต่ใบเสร็จที่ยกเลิกแล้ว ไม่มียอดเงินที่ต้องนำส่งธนาคาร ท่านต้องการปิดงานเพื่อเคลียร์รายการที่ยกเลิกเหล่านี้หรือไม่"}</label></div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-primary w-50" onClick={() => this.setState({ modal_create: false })}>ยกเลิก</button>
              <button className="btn btn-primary w-50" onClick={this.Create}>ยืนยัน</button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={modal_delete} onHide={() => this.setState({ modal_delete: false })}>
          <Modal.Header><Modal.Title><b>ยืนยันการลบใบเสร็จ</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex mb-3"><label>ท่านแน่ใจว่าต้องการลบข้อมูลลูกค้า หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label></div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-primary w-50" onClick={() => this.setState({ modal_delete: false })}>ยกเลิก</button>
              <button className="btn btn-danger w-50" onClick={this.Delete}>ยืนยัน</button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      </div>
    );
  }
}